import React from 'react';
import { Globe, AlertCircle, Shield, Search } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Domain Monitoring feature
 * Displays information about the Domain Monitoring feature and its benefits
 */
export const DomainMonitoringFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Domain Monitoring"
      description="Protect your brand from domain-based threats with comprehensive monitoring of lookalike domains, typosquatting, and domain abuse."
      icon={<Globe className="h-8 w-8 text-blue-600" />}
      featureName="domain-monitoring"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Search className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Typosquatting Detection</h3>
          </div>
          <p className="text-gray-400">
            Identify domains that mimic your brand through common typos, character substitutions, and other deceptive techniques.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertCircle className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Phishing Detection</h3>
          </div>
          <p className="text-gray-400">
            Detect potential phishing domains that target your customers with fraudulent websites and scams.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Globe className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Domain Variations</h3>
          </div>
          <p className="text-gray-400">
            Monitor for domain variations across all TLDs and ccTLDs that could be used to impersonate your brand.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Shield className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Takedown Services</h3>
          </div>
          <p className="text-gray-400">
            Initiate takedown procedures against malicious domains with automated workflows and expert support.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
